import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { UploadSoundModel } from "../UploadSoundModel";
import { EditSoundModel } from "../EditSoundModel";

@Injectable()
export class DataService_SoundMaintenance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	SoundsSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	loadSoundList(applicationID, schoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LoadSoundList?ApplicationID=" + applicationID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadSoundFile(applicationID, soundLibraryID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LoadSoundFile?ApplicationID=" + applicationID + "&SoundLibraryID=" + soundLibraryID;

		var promise$ = this.httpclientService.getSoundFile(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DownloadSoundFile(applicationID, soundLibraryID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/DownloadSoundFile?ApplicationID=" + applicationID + "&SoundLibraryID=" + soundLibraryID;

		var promise$ = this.httpclientService.getSoundFile(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UploadSoundFile(applicationID, schoolID, fileName, soundData, type) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/UploadSoundFile?";

		let parms: UploadSoundModel = {
			SchoolID: schoolID,
			FileName: fileName,
			SoundData: soundData,
			ExpectedType: type,
		};

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EditSoundFile(parms: EditSoundModel) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/EditSoundFile?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	convertAllWav(applicationID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/ConvertAllWAVsToMp3?ApplicationID=" + applicationID;

		var promise$ = this.httpclientService.getSoundFile(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SoundLibraryToggle(SoundLibraryID, Active) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/SoundLibraryToggle?SoundLibraryID=" + SoundLibraryID + "&Active=" + Active;

		var promise$ = this.httpclientService.getSoundFile(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
